import inputValidators from "../helpers/inputValidators";
import selectValidators from "../helpers/selectValidators";
import useType from "./useType";

export const VALIDATIONS = {
  EMAIL: "email",
  TEXT: "text",
  TOKEN: "token",
  SELECT: "select",
};
export function useSpecialValidation(type, value) {
  const [error, setError] = useType("object", {});

  const validator = inputValidators[type];

  const validate = () => setError(validator(value));

  return [error, validate];
}

export function useSelectValidation(value, values) {
  const [error, setError] = useType("object", {});

  const validator = selectValidators[VALIDATIONS.SELECT];

  const validate = () => setError(validator(value, values));

  return [error, validate];
}